import { Global } from '@emotion/react'

export const GlobalStyles = ({
  colorVariant,
  darkMode,
}: {
  colorVariant?: string
  darkMode?: boolean
}) => {
  return (
    <Global
      styles={theme => ({
        body: {
          color: theme.semantic.ColorContentDefault,
          backgroundColor:
            colorVariant === 'grey'
              ? theme.semantic.ColorSurfaceReducedAlternative
              : theme.semantic.ColorBackgroundDefault,
          colorScheme: darkMode ? 'dark' : 'light',
        },
        '#page': {
          position: 'relative',
          zIndex: 0,
        },
      })}
    />
  )
}
